import type React from "react";
import { ReactComponent as Svg } from "./assets/resize.svg";
import * as styles from "./Icon.module.scss";

type ResizeProps = React.SVGProps<SVGSVGElement>;

export const Resize = ({ className, ...props }: ResizeProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
